import { Delete as DeleteIcon, Edit as EditIcon } from "@mui/icons-material";
import {
  Box,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Chip,
  Stack,
  Switch,
} from "@mui/material";
import React from "react";

const NotificationRulesTable = ({
  rules,
  onRequestEdit,
  onRequestDelete,
  onToggleEnabled,
}) => {
  if (!rules || rules.length === 0) {
    return (
      <Typography variant={"body2"} sx={{ padding: 2 }}>
        {"No notification rules configured."}
      </Typography>
    );
  }

  return (
    <TableContainer>
      <Table
        size={"small"}
        aria-label={"Notification Rules"}
        sx={{ "& td, & th": { verticalAlign: "top" } }}
      >
        <TableHead>
          <TableRow>
            <TableCell sx={{ width: 60 }} />
            <TableCell sx={{ width: "30%" }}>{"Trigger Criteria"}</TableCell>
            <TableCell sx={{ width: "25%" }}>{"Recipients"}</TableCell>
            <TableCell sx={{ width: "20%" }}>{"Subject"}</TableCell>
            <TableCell sx={{ width: "20%" }}>{"Template"}</TableCell>
            <TableCell sx={{ width: 96 }} />
          </TableRow>
        </TableHead>
        <TableBody>
          {rules.map((rule) => (
            <TableRow
              key={rule.id}
              sx={{
                "&:hover .row-actions": {
                  visibility: "visible",
                },
              }}
            >
              <TableCell>
                <Switch
                  checked={rule.enabled}
                  onChange={() => onToggleEnabled?.(rule.id)}
                  size={"small"}
                />
              </TableCell>
              <TableCell>
                <Stack spacing={0.5}>
                  {rule.triggerCriteria.map((criteria, idx) => (
                    <Typography key={idx} variant={"body2"}>
                      {`${criteria.path} ${criteria.operator} ${criteria.value}`}
                    </Typography>
                  ))}
                </Stack>
              </TableCell>
              <TableCell>
                <Stack spacing={0.5}>
                  {rule.recipients.map((email, idx) => (
                    <Chip key={idx} label={email} size={"small"} />
                  ))}
                </Stack>
              </TableCell>
              <TableCell>
                <Typography variant={"body2"}>{rule.subject}</Typography>
              </TableCell>
              <TableCell>
                <Typography
                  variant={"body2"}
                  sx={{
                    whiteSpace: "nowrap",
                    maxWidth: "300px",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {rule.template}
                </Typography>
              </TableCell>
              <TableCell align={"right"} sx={{ width: 96 }}>
                <Box
                  className={"row-actions"}
                  sx={{
                    display: "inline-flex",
                    gap: 0.5,
                    visibility: "hidden",
                  }}
                  component={"span"}
                >
                  <IconButton
                    size={"small"}
                    onClick={(e) => {
                      e.stopPropagation();
                      onRequestEdit?.(rule);
                    }}
                    aria-label={"Edit"}
                  >
                    <EditIcon fontSize={"small"} />
                  </IconButton>
                  <IconButton
                    size={"small"}
                    onClick={(e) => {
                      e.stopPropagation();
                      onRequestDelete?.(rule);
                    }}
                    aria-label={"Delete"}
                  >
                    <DeleteIcon fontSize={"small"} />
                  </IconButton>
                </Box>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default NotificationRulesTable;
